import React, { useState, useEffect } from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import Slide from '@material-ui/core/Slide'
import DialogTitle from '@material-ui/core/DialogTitle'
import Fab from '@material-ui/core/Fab'
import { MdClose } from 'react-icons/md'
import { customersService } from '../../_services/customers.service'
import TaskCode from '../Shared/TaskCode'
import Loading from '../Shared/Loading'
import moment from 'moment-jalaali'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const SmsModal = props => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [showModal, setShowModal] = useState(props.show)

  useEffect(() => {
    if (props.show) {
      getData()
    } else {
      setData([])
    }

    setShowModal(props.show)
  }, [props.show])

  const getData = () => {
    if (props.id) {
      setLoading(true)
      customersService
        .gelCustomerSms(props.id)
        .then(res => {
          let result = res.data

          setData(result)
          console.log(res)
          setLoading(false)
        })
        .catch(err => {
          console.log(err)
          setLoading(false)
        })
    }
  }

  const handleCloseModal = () => {
    props.onClose(false)
  }

  return (
    <React.Fragment>
      <Dialog
        open={showModal}
        onClose={() => handleCloseModal()}
        TransitionComponent={Transition}
        scroll={'paper'}
        fullWidth={true}
        maxWidth="lg"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description">
        <DialogTitle>
          <Fab
            color="secondary"
            aria-label="refresh"
            size="small"
            onClick={() => handleCloseModal()}
            className="modal-close-btn">
            <MdClose size="20px" />
          </Fab>
          <span style={{ marginRight: 10 }}>پیامهای ارسال شده به مشتری</span>
        </DialogTitle>
        <DialogContent dividers={true} className="modal-gray-bg">
          <React.Fragment>
            <table className="table table-striped table-hover">
              <thead>
                <tr>
                  <th className="text-center">#</th>
                  <th className="text-center">کد سفارش</th>
                  <th className="text-center">متن پیامک</th>
                  <th className="text-center">شیفت</th>
                  <th className="text-center">تاریخ ارسال</th>
                </tr>
              </thead>
              <tbody>
                {data &&
                  data.length > 0 &&
                  data.map(
                    (item, index) =>
                      item.taskOperation && (
                        <tr>
                          <td>{index + 1}</td>
                          <td>
                            <TaskCode
                              code={
                                item.taskOperation
                                  ? item.taskOperation.task.taskCode
                                  : '-'
                              }
                            />
                          </td>
                          <td style={{ fontSize: 13 }}>{item.text}</td>
                          <td>
                            <div className="shift">
                              {item.taskOperation.shift}
                            </div>
                          </td>
                          <td>
                            {moment(item.createdAt, 'YYYY/M/D H:m').format(
                              'jYYYY/jM/jD ساعت H:mm'
                            )}
                          </td>
                        </tr>
                      )
                  )}
              </tbody>
            </table>
            {loading ? <Loading /> : ''}
          </React.Fragment>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  )
}

export default SmsModal
